export enum MedicationUserTypesEnum {
  Doctor = 1,
  Patient,
  ClinicAdmin
}
